import { IScriptStorageService } from '../ports/script-storage-service.port';
import { useScriptStore } from '../infrastructure/script/store/script-store';

// balanced tree, cycled graph, linked list  check
const scriptStoreService = useScriptStore();
export const useScriptStorageServiceAdapter = (): IScriptStorageService => {
	return scriptStoreService;
};
